module.exports = __webpack_public_path__ + "media/images/edgevana-c31f16b3.png";